import { defineAsyncComponent } from "vue";

// Register components globally
export default function registerComponents(app) {
    app.component(
        "BooleanIndicator",
        defineAsyncComponent(() => import("@components/BooleanIndicator.vue")),
    );
    app.component(
        "BooleanInput",
        defineAsyncComponent(() => import("@components/inputs/BooleanInput.vue")),
    );
    app.component(
        "Container",
        defineAsyncComponent(() => import("@components/Container.vue")),
    );
    app.component(
        "CrudBottomActions",
        defineAsyncComponent(() => import("@components/CrudBottomActions.vue")),
    );
    app.component(
        "DD",
        defineAsyncComponent(() => import("@components/DD.vue")),
    );
    app.component(
        "Debug",
        defineAsyncComponent(() => import("@components/Debug.vue")),
    );
    app.component(
        "DateInput",
        defineAsyncComponent(() => import("@components/inputs/DateInput.vue")),
    );
    app.component(
        "DropdownInput",
        defineAsyncComponent(() => import("@components/inputs/DropdownInput.vue")),
    );
    app.component(
        "DualView",
        defineAsyncComponent(() => import("@components/DualView.vue")),
    );
    app.component(
        "DynamicForm",
        defineAsyncComponent(() => import("@components/DynamicForm.vue")),
    );
    app.component(
        "FA",
        defineAsyncComponent(() => import("@components/FA.vue")),
    );
    app.component(
        "FileInput",
        defineAsyncComponent(() => import("@components/inputs/FileInput.vue")),
    );
    app.component(
        "KeyboardInput",
        defineAsyncComponent(() => import("@components/inputs/KeyboardInput.vue")),
    );
    app.component(
        "ListInput",
        defineAsyncComponent(() => import("@components/inputs/ListInput.vue")),
    );
    app.component(
        "NavButton",
        defineAsyncComponent(() => import("@components/NavButton.vue")),
    );
    app.component(
        "NumberInput",
        defineAsyncComponent(() => import("@components/inputs/NumberInput.vue")),
    );
    app.component(
        "PageSubTitle",
        defineAsyncComponent(() => import("@components/PageSubTitle.vue")),
    );
    app.component(
        "PageTitle",
        defineAsyncComponent(() => import("@components/PageTitle.vue")),
    );
    app.component(
        "PageTitleCrud",
        defineAsyncComponent(() => import("@components/PageTitleCrud.vue")),
    );
    app.component(
        "PageTitleIndex",
        defineAsyncComponent(() => import("@components/PageTitleIndex.vue")),
    );
    app.component(
        "PageTitleView",
        defineAsyncComponent(() => import("@components/PageTitleView.vue")),
    );
    app.component(
        "PaginationNav",
        defineAsyncComponent(() => import("@components/PaginationNav.vue")),
    );
    app.component(
        "PincodeInput",
        defineAsyncComponent(() => import("@components/inputs/PincodeInput.vue")),
    );
    app.component(
        "Popup",
        defineAsyncComponent(() => import("@components/Popup.vue")),
    );
    app.component(
        "Price",
        defineAsyncComponent(() => import("@components/Price.vue")),
    );
    app.component(
        "SaveStatusIndicator",
        defineAsyncComponent(() => import("@components/SaveStatusIndicator.vue")),
    );
    app.component(
        "TableHead",
        defineAsyncComponent(() => import("@components/TableHead.vue")),
    );
    app.component(
        "TableOrderableHeader",
        defineAsyncComponent(() => import("@components/TableOrderableHeader.vue")),
    );
    app.component(
        "TableRowLink",
        defineAsyncComponent(() => import("@components/TableRowLink.vue")),
    );
    app.component(
        "TableRowLinkIndex",
        defineAsyncComponent(() => import("@components/TableRowLinkIndex.vue")),
    );
    app.component(
        "TextAreaInput",
        defineAsyncComponent(() => import("@components/inputs/TextAreaInput.vue")),
    );
    app.component(
        "TextInput",
        defineAsyncComponent(() => import("@components/inputs/TextInput.vue")),
    );
    app.component(
        "TimeInput",
        defineAsyncComponent(() => import("@components/inputs/TimeInput.vue")),
    );
    app.component(
        "YTable",
        defineAsyncComponent(() => import("@components/YTable.vue")),
    );
    app.component(
        "YTableRowEmpty",
        defineAsyncComponent(() => import("@components/YTableRowEmpty.vue")),
    );
}
